import { createElement, useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 24px;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  margin-left: 25px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  color: #979797;\n  font-size: 10px;\n  font-weight: 300;\n  line-height: 18px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: 300;\n  margin-left: 30px;\n  margin-right: 0;\n\n  @media (max-width: 767px) {\n    margin-left: 0;\n  }\n\n  @media (max-width: 479px) {\n    font-weight: 500;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  margin-right: 30px;\n  text-decoration: none;\n\n  @media (max-width: 767px) {\n    margin-bottom: 15px;\n    margin-right: 0;\n    text-align: center;\n  }\n\n  @media (max-width: 479px) {\n    font-size: 18px;\n    line-height: 26px;\n    margin-bottom: 20px;\n    text-align: left;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  @media (max-width: 479px) {\n    padding-left: 2.5%;\n    padding-right: 0%;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  @media (max-width: 767px) {\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    min-width: 100%;\n    width: 19%;\n  }\n\n  @media (max-width: 479px) {\n    max-width: none;\n    min-width: 45%;\n    padding-right: 2.5%;\n    width: auto;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  @media (max-width: 767px) {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  @media (max-width: 479px) {\n    flex-direction: row;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  flex: 0 auto;\n  justify-content: space-between;\n  margin: 0px;\n  max-width: 960px;\n  order: 0;\n  padding: 0px;\n  transform-style: preserve-3d;\n  transform: translate3d(0px, 0px, 1px);\n  width: 960px;\n\n  @media (max-width: 991px) {\n    flex: 1;\n    margin-left: 22px;\n    margin-right: 22px;\n  }\n\n  @media (max-width: 767px) {\n    margin-left: 18px;\n    margin-right: 18px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #212121;\n  height: 85px;\n  max-height: 85px;\n  min-height: 85px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #1a1a19;\n  border: 1px none #000;\n  height: 215px;\n  max-height: 215px;\n  min-height: 215px;\n\n  @media (max-width: 767px) {\n    height: auto;\n    max-height: none;\n    min-height: auto;\n    padding-top: 15px;\n  }\n\n  @media (max-width: 479px) {\n    padding-bottom: 65px;\n    padding-top: 85px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #1a1a19;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var DOMAIN = 'https://saytechnologies.com';

var Footer = function Footer() {
  return createElement(Wrapper, null, createElement(SectionSuper, null, createElement(ContentWrapperSuper, null, createElement(StackFooterLinks, null, createElement(Link, {
    href: DOMAIN + "/broker"
  }, "Broker-Dealers"), createElement(Link, {
    href: DOMAIN + "/investor"
  }, "Investors"), createElement(Link, {
    href: DOMAIN + "/public-company"
  }, "Public Companies")), createElement(StackFooterLinksRight, null, createElement(LinkRight, {
    href: DOMAIN + "/blog"
  }, "Blog"), createElement(LinkRight, {
    href: DOMAIN + "/careers"
  }, "Careers"), createElement(LinkRight, {
    href: DOMAIN + "/terms"
  }, "Legal"), createElement(LinkRight, {
    href: "mailto:hello@saytechnologies.com?subject=Hi%20Say%20Team"
  }, "Email Us")))), createElement(SectionSub, null, createElement(ContentWrapper, null, createElement(Copyright, null, "SAY \xA9 ", new Date().getFullYear()), createElement("div", null, createElement(SocialLink, {
    href: "https://twitter.com/say"
  }, createElement(BrandIcon, {
    icon: faTwitter,
    color: "white"
  })), createElement(SocialLink, {
    href: "https://www.linkedin.com/company/asayinc/"
  }, createElement(BrandIcon, {
    icon: faLinkedinIn,
    color: "white"
  })), createElement(SocialLink, {
    href: "https://instagram.com/say"
  }, createElement(BrandIcon, {
    icon: faInstagram,
    color: "white"
  }))))));
};
var Wrapper =
/*#__PURE__*/
styled.footer(
/*#__PURE__*/
_templateObject());
var Section =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2());
var SectionSuper =
/*#__PURE__*/
styled(Section)(
/*#__PURE__*/
_templateObject3());
var SectionSub =
/*#__PURE__*/
styled(Section)(
/*#__PURE__*/
_templateObject4());
var ContentWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject5());
var ContentWrapperSuper =
/*#__PURE__*/
styled(ContentWrapper)(
/*#__PURE__*/
_templateObject6());
var StackFooterLinks =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject7());
var StackFooterLinksRight =
/*#__PURE__*/
styled(StackFooterLinks)(
/*#__PURE__*/
_templateObject8());
var Link =
/*#__PURE__*/
styled.a(
/*#__PURE__*/
_templateObject9());
var LinkRight =
/*#__PURE__*/
styled(Link)(
/*#__PURE__*/
_templateObject10());
var Copyright =
/*#__PURE__*/
styled.span(
/*#__PURE__*/
_templateObject11());
var SocialLink =
/*#__PURE__*/
styled.a(
/*#__PURE__*/
_templateObject12());
var BrandIcon =
/*#__PURE__*/
styled(FontAwesomeIcon)(
/*#__PURE__*/
_templateObject13());

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 10px;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #979797;\n  background-color: #fff;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n  align-self: center;\n  background-color: #1c9;\n  border-radius: 100px;\n  border: 0;\n  color: #1a1a19;\n  cursor: pointer;\n  display: inline-block;\n  font-weight: 500;\n  line-height: inherit;\n  margin-bottom: 0px;\n  margin-right: 0px;\n  margin-top: 0px;\n  max-width: 75vw;\n  min-width: 74vw;\n  padding: 13px 30px 10px;\n  text-align: center;\n  text-decoration: none;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  padding-top: 120px;\n  padding-bottom: 20px;\n  flex-direction: column;\n  align-items: center;\n  align-self: center;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n  @media (max-width: 991px) {\n    color: #1a1a19;\n    font-size: 24px;\n    line-height: 28px;\n    font-weight: 300;\n    text-align: left;\n    padding-left: 0;\n    padding-right: 0;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding: 10px 20px;\n"]);

  _templateObject13$1 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n\n  @media (max-width: 479px) {\n    position: absolute;\n    top: 50.5px;\n    z-index: 1986;\n    width: 100vw;\n    height: 1200vh;\n    max-width: 100vw;\n    min-height: 1200vh;\n    min-width: 100vw;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: stretch;\n    border-style: solid;\n    border-width: 1px;\n    border-color: #e5e5e5;\n    background-color: #fff;\n    transform: ", ";\n    transform-style: preserve-3d;\n    display: ", ";\n  }\n"]);

  _templateObject12$1 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$1() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  z-index: 1;\n  width: auto;\n  max-height: 31px;\n  max-width: none;\n  min-width: 10px;\n"]);

  _templateObject11$1 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$1() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: 300;\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$1() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 10px 20px;\n  color: #1a1a19;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 18px;\n  text-align: center;\n  text-decoration: none;\n\n  @media (max-width: 991px) {\n    padding: 10px;\n    order: 0;\n  }\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 24.75vw;\n  max-width: 85px;\n  min-width: 24.7px;\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: auto;\n  height: 15px;\n  max-height: 15px;\n  max-width: none;\n  min-height: 15px;\n  min-width: auto;\n  margin-top: 24px;\n  margin-right: 80px;\n  margin-bottom: 24px;\n\n  @media (max-width: 991px) {\n    position: static;\n  }\n\n  @media (max-width: 767px) {\n    margin-right: 15px;\n  }\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: transparent;\n  border: none;\n  display: flex;\n  width: 10px;\n  height: 31px;\n  max-height: 31px;\n  max-width: 10px;\n  min-height: 31px;\n  min-width: 10px;\n  padding-right: 30px;\n  justify-content: flex-start;\n  align-items: center;\n  flex: 0 0 auto;\n  outline: none;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n\n  @media (max-width: 479px) {\n    position: relative;\n    display: flex;\n    margin: 10px 18px;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    flex: 1;\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  max-width: 960px;\n  width: 960px;\n\n  @media (max-width: 991px) {\n    margin-left: 22px;\n    margin-right: 22px;\n  }\n\n  @media (max-width: 479px) {\n    display: none;\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  background-color: #fff;\n  border-color: #e5e5e5;\n  border-style: none none solid;\n  border-width: 1px;\n  display: flex;\n  justify-content: center;\n  max-width: none;\n  overflow: visible;\n  padding-bottom: 0px;\n  padding-top: 0px;\n  position: sticky;\n  top: 0px;\n  z-index: 200;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var DOMAIN$1 = 'https://saytechnologies.com';
var QA_URL = 'https://app.saytechnologies.com';

var Header = function Header() {
  var _React$useState = useState(false),
      isMobileNavOpen = _React$useState[0],
      setIsMobileNavOpen = _React$useState[1];

  var toggleMobileNav = function toggleMobileNav() {
    return setIsMobileNavOpen(function (state) {
      return !state;
    });
  };

  return createElement(HeaderWrapper, null, createElement(MobileDropdown, {
    isOpen: isMobileNavOpen
  }, createElement(MobileDropdownLinkList, null, createElement(MobileDropdownLink, {
    href: DOMAIN$1 + "/broker"
  }, "Broker-Dealers"), createElement(MobileDropdownLink, {
    href: DOMAIN$1 + "/investor"
  }, "Investors"), createElement(MobileDropdownLink, {
    href: DOMAIN$1 + "/public-company"
  }, "Public Companies"), createElement(MobileDropdownLink, {
    href: DOMAIN$1 + "/blog"
  }, "Blog")), createElement(MobileDropdownLinkButtons, null, createElement(LinkButton, {
    href: DOMAIN$1 + "/contact"
  }, "Contact sales"), createElement(LinkButtonWire, {
    href: QA_URL
  }, "Sign in"))), createElement(MobileNav, null, createElement("a", {
    href: DOMAIN$1 + "/"
  }, createElement(MobileLogo, {
    src: "https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5d9a9fedc33c896b2582b7fc_SAY.Wordmark.RGB.Black.png",
    width: "98",
    srcSet: "https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5d9a9fedc33c896b2582b7fc_SAY.Wordmark.RGB.Black-p-500.png 500w, https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5d9a9fedc33c896b2582b7fc_SAY.Wordmark.RGB.Black-p-800.png 800w, https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5d9a9fedc33c896b2582b7fc_SAY.Wordmark.RGB.Black.png 1000w",
    sizes: "(max-width: 479px) 25vw, 100vw",
    alt: "Say"
  })), createElement(HamburgerButton, {
    type: "button",
    onClick: toggleMobileNav
  }, isMobileNavOpen ? createElement(ControlIcon, {
    src: "https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5df2a691c2725f2dc58e3e70_x_button.png",
    srcSet: "https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5df2a691c2725f2dc58e3e70_x_button-p-500.png 500w, https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5df2a691c2725f2dc58e3e70_x_button.png 512w",
    sizes: "100vw",
    alt: "Close"
  }) : createElement(ControlIcon, {
    src: "https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5df2a526f989fa2a2becf1d4_menu_icon.png",
    srcSet: "https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5df2a526f989fa2a2becf1d4_menu_icon-p-500.png 500w, https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5df2a526f989fa2a2becf1d4_menu_icon.png 512w",
    sizes: "(max-width: 479px) 30.99431800842285px, 100vw",
    alt: "Show more"
  }))), createElement(Nav, null, createElement(LogoLink, {
    href: DOMAIN$1 + "/"
  }, createElement(Logo, {
    src: "https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5d9a9fedc33c896b2582b7fc_SAY.Wordmark.RGB.Black.png",
    width: "100",
    height: "25",
    srcSet: "https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5d9a9fedc33c896b2582b7fc_SAY.Wordmark.RGB.Black-p-500.png 500w, https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5d9a9fedc33c896b2582b7fc_SAY.Wordmark.RGB.Black-p-800.png 800w, https://assets.website-files.com/5d898ad5b4e4f742d9f7ba40/5d9a9fedc33c896b2582b7fc_SAY.Wordmark.RGB.Black.png 1000w",
    sizes: "(max-width: 479px) 100vw, 60.48295211791992px",
    alt: "Say"
  })), createElement(MainLinks, null, createElement(Link$1, {
    href: DOMAIN$1 + "/broker"
  }, "Broker-Dealers"), createElement(Link$1, {
    href: DOMAIN$1 + "/investor"
  }, "Investors"), createElement(Link$1, {
    href: DOMAIN$1 + "/public-company"
  }, "Public Companies")), createElement(LinkLight, {
    href: DOMAIN$1 + "/contact/sales"
  }, "Contact Sales"), createElement(LinkLight, {
    href: QA_URL
  }, "Sign in \u2192")));
};
var HeaderWrapper =
/*#__PURE__*/
styled.header(
/*#__PURE__*/
_templateObject$1());
var Nav =
/*#__PURE__*/
styled.nav(
/*#__PURE__*/
_templateObject2$1());
var MobileNav =
/*#__PURE__*/
styled.nav(
/*#__PURE__*/
_templateObject3$1());
var HamburgerButton =
/*#__PURE__*/
styled.button(
/*#__PURE__*/
_templateObject4$1());
var LogoLink =
/*#__PURE__*/
styled.a(
/*#__PURE__*/
_templateObject5$1());
var Logo =
/*#__PURE__*/
styled.img(
/*#__PURE__*/
_templateObject6$1());
var MobileLogo =
/*#__PURE__*/
styled.img(
/*#__PURE__*/
_templateObject7$1());
var MainLinks =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject8$1());
var Link$1 =
/*#__PURE__*/
styled.a(
/*#__PURE__*/
_templateObject9$1());
var LinkLight =
/*#__PURE__*/
styled(Link$1)(
/*#__PURE__*/
_templateObject10$1());
var ControlIcon =
/*#__PURE__*/
styled.img(
/*#__PURE__*/
_templateObject11$1());
var MobileDropdown =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject12$1(), function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? 'translate3d(0px, 0px, 5px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)' : 'none';
}, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? 'block' : 'none';
});
var MobileDropdownLinkList =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject13$1());
var MobileDropdownLink =
/*#__PURE__*/
styled(Link$1)(
/*#__PURE__*/
_templateObject14());
var MobileDropdownLinkButtons =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject15());
var LinkButton =
/*#__PURE__*/
styled.a(
/*#__PURE__*/
_templateObject16());
var LinkButtonWire =
/*#__PURE__*/
styled(LinkButton)(
/*#__PURE__*/
_templateObject17());

export { Footer, Header };
//# sourceMappingURL=components.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@asayinc/components/dist/components.esm.js
// module id = 390
// module chunks = 0